<template>
    <div class="text-center" >
        <div v-if="getCreditLimitSystem[0]">
            <div v-if="getCreditLimitSystem[0].credit_limit_system">
                <vx-tooltip :text="$t('counter_reg', { limit_min: limit.min,limit_max:limit.max })" position="left">
                <span :class="{red:lenit,green:!lenit}" class="style_count ">
                {{limit.current}}/{{limit.max}}
                </span>
                </vx-tooltip>
            </div>
        </div>
        <div v-else>
            <vx-tooltip :text="$t('collected_number_of_credits')" position="left">
                <span :class="{red:lenit,green:!lenit}" class="style_count ">
                    {{limit.current}}
                </span>
            </vx-tooltip>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import CounterMixin from './DisList/CounterMixin.vue'
export default {
    data() {
        return {
            red_watch:undefined,
            red_watch_test:false
        }
    },
    mixins:[CounterMixin],
    computed:{
        ...mapGetters({
            limit:'regis_discepline/limitDiscepline',
            exceed_limit:'regis_discepline/limitExceed',
            obj_count: "ApplicationForISC/application",
            getCreditLimitSystem:"regis_discepline/getCreditLimitSystem"
        }),

        classRG(){
            return this.red_watch?'red':'green'
        },
        classExceed(){
            return this.exceed_limit?'red':''
        },
        user() {
            return this.$store.state.user.user
        },
        lenit(){
            if (this.limit.current >= this.limit.min){
                return false

            }else {
                return true
            }
        }


    },
    async created() {
        if (this.user.role.is_supervisor){
            await this.CREDIT_LIMIT_SYSTEM()
        }
    },
    watch:{},
    methods: {
        ...mapActions({
            CREDIT_LIMIT_SYSTEM:'regis_discepline/CREDIT_LIMIT_SYSTEM'
        }),
        ...mapMutations({
            setExceeding:'regis_discepline/SET_EXCEED',// установка повышение лимита
            CLEAR_DISCEPLINE:'regis_discepline/CLEAR_DISCEPLINE',// установка повышение лимита
        }),
    },
    destroyed() {
        this.CLEAR_DISCEPLINE()
    }

}
</script>

<style lang="css" scoped>
    .red{
        color: red;
        font-weight: 600;
    }
    .green{
        color: #2E8B57;
        font-weight: 600;
    }
    .style_count{
        margin-right: -0px;
        font-size: 16px;
        font-weight: 600;
        text-align: right;
    }
</style>
